<template>
	<rect x="1.5" y="3" width="13" height="10" rx="2" stroke="currentColor" stroke-width="1.4" fill="none" />
	<path
		d="M7 6.9c-.3-.35-.72-.55-1.2-.55-.94 0-1.6.72-1.6 1.65s.66 1.65 1.6 1.65c.48 0 .9-.2 1.2-.55M12 6.9c-.3-.35-.72-.55-1.2-.55-.94 0-1.6.72-1.6 1.65s.66 1.65 1.6 1.65c.48 0 .9-.2 1.2-.55"
		stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round" />
</template>
